import React from 'react'
import styled from 'styled-components'

const LoadingIndicator = styled.div`  
  margin-left: auto !important;
  margin-right: auto !important;
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
  color: #001bb3;
  font-size: 10px;
  
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  
  &:before, &:after {    
    content: '';
    position: absolute;
    top: 0;
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
  }
  
  &:before {
    left: -3.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  
  &:after {
    left: 3.5em;
  }
  
  @-webkit-keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
`

const LoaderLine = ({ containerStyle, loaderStyle }) => {
  return (
    <div
      style={{
        height: 75,
        flexGrow: 1,
        ...(containerStyle || {}),
      }}
      title="Подождите, идёт загрузка"
    >
      <LoadingIndicator
        className="loader"
        style={{
          ...(loaderStyle || {})
        }}
      />
    </div>
  )
}

export default LoaderLine


// WEBPACK FOOTER //
// ./src/basic/LoaderLine.js